import { getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');

const borderRadiusLg = getTheme('borderRadius.lg');

const borderWidthXxs = getTheme('borderWidth.xxs');

const spacingMd = getTheme('spacing.md');

export const Wrapper = styled.div`
  border: ${borderWidthXxs}px solid ${textMain}1a;
  border-radius: ${borderRadiusLg}px;
  overflow: auto;
`;

export const Root = styled.table`
  border-spacing: 0;
  width: 100%;
`;

export const THead = styled.thead`
  background: ${textMain}0a;
  height: 50px;
`;

export const Th = styled.th`
  font-size: ${pxToRem(16)};
  color: ${textMain};
  font-weight: 500;
  padding: 0 ${spacingMd}px;
  text-align: start;

  word-wrap: break-word;
  white-space: normal;
`;

export const TBody = styled.tbody`
  > tr:not(:last-child) > td {
    border-bottom: ${borderWidthXxs}px solid ${textMain}20;
  }
`;

export const Tr = styled.tr`
  height: 50px;
  border-bottom: ${borderWidthXxs}px solid ${textMain}1a;
`;

export const Td = styled.td`
  font-size: ${pxToRem(16)};
  font-weight: 400;
  padding: 0 ${spacingMd}px;
  color: ${textMain}e6;
  word-wrap: break-word;
  white-space: normal;
`;
